export default {
	title: '体检报告',
	selectAll: '全选',
	selectedCount: '已选择 {count} 项',
	batchDelete: '批量删除',
	batchDeleteWithCount: '批量删除 ({count})',
	sendEmail: '发送邮件',
	sendEmailWithCount: '发送邮件 ({count})',
	noData: {
		title: '暂无体检报告',
		description: '当前没有找到相关的体检报告数据'
	},
	reportCard: {
		coverAlt: '体检报告封面',
		author: '编制人',
		approver: '审批人',
		updateTime: '更新时间'
	},
	actions: {
		add: '新增',
		generateReport: '生成报告',
		download: '下载',
		modify: '修改',
		delete: '删除',
		sendEmail: '发送邮件',
		batchDelete: '批量删除'
	},
	emailDialog: {
		title: '发送邮件',
		ccPerson: '抄送人',
		selectCcPerson: '请选择抄送人',
		cancel: '取消',
		confirm: '确定'
	},
	messages: {
		selectReportWarning: '请选择诊断报告',
		selectCcPersonWarning: '请选择抄送人',
		sendSuccess: '发送成功',
		deleteConfirm: '确定删除选中的 {count} 项记录吗？',
		deleteSuccess: '删除成功',
		selectDeleteWarning: '请选择删除记录',
		generateReportSuccess: '生成报告成功',
		operateSuccess: '操作成功',
		selectedCount: '已选择 {count} 项'
	},
	form: {
		fileName: '报告名称',
		startTime: '开始时间',
		endTime: '结束时间',
		reportTitle: '报告标题',
		author: '编制人',
		approver: '审批人',
		orgId: '所属部门',
		result: '诊断结果',
		fileViewInDoc: '文件内查看',
		equipmentCheckReport: '体检报告',
		requiredFieldCannotBeEmpty: '必填项不能为空',
		add: '新增',
		update: '修改',
		deviceName: '设备名称',
		deviceParams: '设备参数',
		paramName: '参数名称',
		paramValue: '参数值',
		addParam: '添加参数',
		reviewer: '校核人',
		diagnosis: '诊断分析',
		advice: '维护建议',
		sensorPicPath: '测点示意图',
		vibrationData: '状态监测数据',
		sensorName: '测点名称',
		vibrationH: '振动水平速度 mm/s',
		vibrationV: '振动垂直速度 mm/s',
		vibrationA: '振动轴向速度 mm/s',
		vibrationAcc: '振动加速度 m/s²',
		addSensorData: '添加测点数据',
		attachment: '附件上传',
		uploadFile: '文件上传',
		picturePreview: '预览图'
	},
	table: {
		reportTitle: '报告标题',
		equipmentCheckReport: '体检报告',
		author: '编制人',
		approver: '审批人',
		orgId: '所属部门',
		result: '诊断结果',
		updateTime: '诊断时间'
	}
}
